<template>
  <li
    class="rec-swiper-item"
    :style="{ backgroundImage }"
    @click="clickFeed()"
  >
    <div class="mask">
      <div class="desc">
        {{ feed.feedDescWithat }}
      </div>
      <div class="play-num">
        <i />{{ playNum }}
      </div>
    </div>
    <JumpMiniApp
      v-if="miniAppPathClickRecItem"
      :path="miniAppPathClickRecItem"
      @launch="clickFeed(true)"
    />
  </li>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { ModelMetaFeed } from '@/types/model';
import { EMiniAppPosition } from '@/constants/mini-app';
import useGetCommonMethods from '@/composable/use-get-common-method';
import { addNumUint } from '@/utils/number';
import { fixHttps } from '@/utils/no-import-meta/url';
import JumpMiniApp from '@/components/common/jump-mini-app.vue';

const enum EEmitEvent {
  onClickFeed = 'on-click-feed',
}

export default defineComponent({
  components: {
    JumpMiniApp,
  },
  props: {
    feed: {
      type: Object as PropType<ModelMetaFeed>,
      default: () => ({}),
    },
  },
  emits: [EEmitEvent.onClickFeed],
  setup() {
    const { getMiniAppPath } = useGetCommonMethods();
    return {
      getMiniAppPath,
    };
  },
  computed: {
    backgroundImage() {
      return `url(${fixHttps(this.feed?.images?.[0]?.url)})`;
    },
    playNum() {
      return addNumUint(this.feed.playNum, 'cn');
    },
    miniAppPathClickRecItem() {
      return this.getMiniAppPath(EMiniAppPosition.recommendVideo, { feedId: this.feed.id, outFrom: 10001 });
    },
  },
  methods: {
    clickFeed(clickMiniApp = false) {
      this.$emit(EEmitEvent.onClickFeed, this.feed, clickMiniApp);
    },
  },
});
</script>

<style lang="scss" scoped>
.rec-swiper-item {
  position: relative;
  width: 47%;
  @include responsiveStyleSingle(height, 65, 'vw');
  overflow: hidden;
  @include responsiveStyleSingle(margin-bottom, 2, 'vw');
  @include responsiveStyleSingle(margin-left, 1.333, 'vw');
  @include responsiveStyleSingle(margin-right, 1.333, 'vw');
  @include responsiveStyleSingle(border-radius, 1.3333, 'vw');
  background-size: cover;
  .mask {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    width: 100%;
    height: 100%;
    @include responsiveStyleSingle(padding-right, 2.1333,'vw');
    @include responsiveStyleSingle(padding-bottom, 2.6667,'vw');
    @include responsiveStyleSingle(padding-left, 2.4,'vw');
    @include responsiveStyleSingle(font-size, 3.7333, 'vw');
    word-break: break-all;
    background-image: linear-gradient(180deg, transparent 41%, rgba(0, 0, 0, 0.6));
    .desc {
      display: -webkit-box;
      overflow: hidden;
      word-break: break-all;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    }
    .play-num {
      display: flex;
      align-items: center;
      @include responsiveStyleSingle(margin-top,1.3333, 'vw');
      i {
        display: inline-block;
        @include responsiveStyleSingle(width, 4.2667, 'vw');
        @include responsiveStyleSingle(height, 4.2667, 'vw');
        @include responsiveStyleSingle(margin-right, 0.5333, 'vw');
        background: url('https://sola.gtimg.cn/aoi/sola/20200722113748_OlyNJSgSsR.png');
        background-size: 100% 100%;
      }
    }
  }
}
</style>
